export default __webpack_public_path__ + "static/media/detail_one.907d0618.png";